import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import useApi from 'utils/hooks/api/useApi';
import { HTTP_VERBS } from 'utils/constants';
import { ALERT_VARIANTS } from 'utils/constants';
import { useRoot } from 'context/RootContext';
import { LOCALIZATION_PAGES } from 'utils/constants';
import { API_ENDPOINTS } from 'utils/constants';

const path = API_ENDPOINTS.VENUES;

const useVenueDeleteSeats = id => {
  const { t } = useTranslation(LOCALIZATION_PAGES.VENUES);
  const { showNotification } = useRoot();

  const [{ result: deleteSeatsResult, loading: loadingDeleteSeats, error }, deleteSeats] = useApi(
    `${path}/${id}/seats`,
    {
      initialFetch: false,
      verb: HTTP_VERBS.DELETE,
    }
  );

  useEffect(() => {
    if (error) {
      showNotification(
        {
          message: t('seats_delete_failed'),
        },
        ALERT_VARIANTS.DANGER
      );
    }
  }, [error, showNotification, t]);

  useEffect(() => {
    if (deleteSeatsResult) {
      showNotification({
        message: t('seats_delete_success'),
      });
    }
  }, [deleteSeatsResult, showNotification, t]);

  return [{ deleteSeatsResult, loadingDeleteSeats, error }, deleteSeats];
};

export default useVenueDeleteSeats;
